<template>
  <div class="contract" @scroll="scrolling">
    <div class="top1" :style="{ backgroundImage: `url(${aboutuList?.top_banner?.image})` }">

      <!-- <div class="top1-1">
        <img :src="aboutuList?.set?.site_logo" alt="" />
      </div> -->

      <div class="toptab" :style="{
      backgroundColor: isDropdown ? '#fff' : 'transparent',
      boxShadow:
        isDropdown
          ? '0px 2px 7px 0px rgba(152,161,168,0.27)'
          : 'none',
    }">
        <div class="topbox">

        <div class="toptab-logo"><img class="toptab-logo" :src="aboutuList?.set?.site_logo" alt="" /></div>
        <div class="switch">
          <div class="tab" :class="activeTab == index ? 'active' : ''" :style="index == 1 ? 'margin:0 100px' : ''"
            v-for="(item, index) in tabs" :key="index" @click="clickTab(index)">
            <div class="line" v-if="activeTab == index"></div>
            {{ item }}
          </div>
        </div>
      </div>

      </div>

      <div class="top1-title">
        <div> {{ aboutuList?.top_banner?.title }}</div>
        <!-- <div></div> -->
      </div>

    </div>

    <div class="bottom1">
      <div class="bottom1-title">{{ aboutuList?.aboutus?.title }}</div>
      <div class="bottom1-top">
        <div class="bottom1-top-img">
          <img class="bottom1-top-img" :src="aboutuList?.aboutus?.image" alt="">
        </div>
        <div class="bottom1-top-content" v-html="aboutuList?.aboutus?.intro"></div>
      </div>
      <div class="bottom1-midd">
        <div v-for="(item, index) in aboutuList?.aboutus?.content" :key="index">
          <div class="bottom1-midd-num">{{ item.data }}</div>
          <div class="bottom1-midd-text">{{ item.text }}</div>
        </div>
      </div>

      <div class="bottom1-three">合作伙伴</div>

      <div style="display: flex;width: 100%;justify-content: center;align-items: center;">

        <div class="bottom1-left" style="margin-right: -50px;" id="one">
          <img class="bottom1-left-img" src="../../public/images/left.png" alt="">
        </div>

        <div class="bottom1-last" v-if="aboutuList.links">

          <div style="width: 100%;display: flex;" v-if="aboutuList?.links.length <= 7 && aboutuList?.links.length > 0">
            <div class="bottom1-last-case" v-for="(item, index) in aboutuList?.links.slice(0, 7)" :key="index">
              <img class="bottom1-last-case-img" :src="item.image" alt="">
            </div>
          </div>

          <div style="width: 100%;display: flex;margin-left: 80px;"
            v-if="aboutuList?.links.length < 13 && aboutuList?.links.length > 7">
            <div class="bottom1-last-case " v-for="(item, index) in aboutuList?.links.slice(7, 13)" :key="index">
              <img class="bottom1-last-case-img" :src="item.img" alt="">
            </div>
          </div>

          <div style="width: 100%;display: flex;" v-if="aboutuList?.links.length < 20 && aboutuList?.links.length > 13">
            <div class="bottom1-last-case" v-for="(item, index) in aboutuList?.links.slice(13, 20)" :key="index">
              <img class="bottom1-last-case-img" :src="item.img" alt="">
            </div>
          </div>

          <div style="width: 100%;display: flex;margin-left: 80px;"
            v-if="aboutuList?.links.length < 26 && aboutuList?.links.length > 20">
            <div class="bottom1-last-case" v-for="(item, index) in aboutuList?.links.slice(20, 26)" :key="index">
              <img class="bottom1-last-case-img" :src="item.img" alt="">
            </div>
          </div>

          <div style="width: 100%;display: flex;" v-if="aboutuList?.links.length < 33 && aboutuList?.links.length > 26">
            <div class="bottom1-last-case" v-for="(item, index) in aboutuList?.links.slice(26, 33)" :key="index">
              <img class="bottom1-last-case-img" :src="item.img" alt="">
            </div>
          </div>

          <div style="width: 100%;display: flex;margin-left: 80px;"
            v-if="aboutuList?.links.length < 39 && aboutuList?.links.length > 33">
            <div class="bottom1-last-case" v-for="(item, index) in aboutuList?.links.slice(33, 39)" :key="index">
              <img class="bottom1-last-case-img" :src="item.img" alt="">
            </div>
          </div>

          <div style="width: 100%;display: flex;" v-if="aboutuList?.links.length < 46 && aboutuList?.links.length > 39">
            <div class="bottom1-last-case" v-for="(item, index) in aboutuList?.links.slice(39, 46)" :key="index">
              <img class="bottom1-last-case-img" :src="item.img" alt="">
            </div>
          </div>

          <div style="width: 100%;display: flex;margin-left: 80px;"
            v-if="aboutuList?.links.length < 46 && aboutuList?.links.length > 52">
            <div class="bottom1-last-case" v-for="(item, index) in aboutuList?.links.slice(46, 52)" :key="index">
              <img class="bottom1-last-case-img" :src="item.img" alt="">
            </div>
          </div>

          <div style="width: 100%;display: flex;" v-if="aboutuList?.links.length < 60 && aboutuList?.links.length > 52">
            <div class="bottom1-last-case" v-for="(item, index) in aboutuList?.links.slice(52, 60)" :key="index">
              <img class="bottom1-last-case-img" :src="item.img" alt="">
            </div>
          </div>

        </div>

        <div class="bottom1-left" style="margin-left: -50px;" id="two">
          <img class="bottom1-left-img" src="../../public/images/right.png" alt="">
        </div>

      </div>


    </div>
    <bottomBar v-if="aboutuList.links"></bottomBar>

  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from "vue";
import { aboutuInfo } from "../api/home.js"
import { useRouter, useRoute } from "vue-router";
import bottomBar from "@/components/bottomBar.vue";

const router = useRouter();
const route = useRoute();

const aboutuList = ref({})

const tabs = ref(["首页", "关于我们", "联系我们"]);
const activeTab = ref<any>(1);
// activeTab.value = localStorage.getItem("activeTab") ? localStorage.getItem("activeTab") : 1;

const clickTab = (index: any) => {
  // localStorage.setItem("activeTab", index.toString());
  activeTab.value = index
  index == 0
    ? router.push("/")
    : index == 1
      ? router.push("/contract")
      : router.push("/about");
};


const isDropdown = ref(false)
const scrolling = (e:any) => {
  if (e.target.scrollTop >= 100) {
    isDropdown.value = true
  } else {
    isDropdown.value = false
  }
}
const getInfo = async () => {
  try {
    const { data } = await aboutuInfo()
    aboutuList.value = data.data
    nextTick(() => {
      getHeight()
    })
  } catch (error) {
    console.log(error)
  }
}


const getHeight = () => {
  const height = document.getElementsByClassName('bottom1-last');
  const ele1 = document.getElementById('one');
  const ele2 = document.getElementById('two');

  if (ele1 !== null && height.length > 0 && height[0] !== null) {
    ele1.style.height = `${height[0].clientHeight}px`;
  }

  if (ele2 !== null && height.length > 0 && height[0] !== null) {
    ele2.style.height = `${height[0].clientHeight}px`;
  }

}


onMounted(() => {
  getInfo()
});

</script>

<style lang="scss" scoped>
.contract {
  width: 100%;
  height: 100vh;
  // overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;


  .top1 {
    height: 530px;
    width: 100%;
    background-size: cover;
    background-position: center center;
    padding-top: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;

    .top1-1 {
      width: 62.5%;
      height: 55px;
    }

    img {
      width: 155px;
      height: 55px;
    }

    .top1-title {
      display: flex;
      align-items: center;
      width: 1200px;
      font-weight: 600;
      font-size: 64px;
      color: #333333;
      height: 510px;
    }

  }

  .bottom1 {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 100px 0 130px 0;
    box-sizing: border-box;

    .bottom1-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 42px;
      color: #333333;
      line-height: 59px;
      text-align: center;
      font-style: normal;
    }

    .bottom1-top {
      display: flex;
      margin: 70px 0 90px 0;

      .bottom1-top-img {
        width: 482px;
        height: 380px;
        border-radius: 20px;
        margin-right: 60px;
      }

      .bottom1-top-content {
        width: 658px;
        height: 368px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 46px;
      }
    }

    .bottom1-midd {
      width: 1200px;
      height: 200px;
      background: #F8F8F8;
      border-radius: 20px;
      display: flex;
      justify-content: space-around;
      padding: 58px 121px 58px 121px;
      box-sizing: border-box;

      .bottom1-midd-num {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 36px;
        color: #266EFF;
        line-height: 50px;
        text-align: center;
      }

      .bottom1-midd-text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
        margin-top: 8px;
      }
    }

    .bottom1-three {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 42px;
      color: #333333;
      line-height: 59px;
      margin: 90px 0 80px 0;
    }

    .bottom1-last {
      width: 1200px;
      background: #f8f8f8;
      display: flex;
      flex-wrap: wrap;
      padding: 24px 8px;
      box-sizing: border-box;
      // position: absolute;

      .bottom1-last-case {
        width: 148px;
        height: 88px;
        background: #FFFFFF;
        border-radius: 4px;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        .bottom1-last-case-img {
          width: 88px;
          height: 44px;
        }
      }
    }

    .bottom1-left {
      // position: relative;
      z-index: 999;
      // top: -8px;
      height: 100%;

      .bottom1-left-img {
        width: 128px;
        height: 100%;
        // height: 460px;
        // height: auto;
      }
    }
  }
}

.toptab {
  display: flex;
  justify-content: center;
  width: 99%;
  height: 70px;
  position: fixed;
  top: 0;
  z-index: 9999;

  .topbox {
    width: 1200px;
    display: flex;
    justify-content: space-between;
  }

  .toptab-logo {
    width: 150px;
    height: 55px;
    margin-top:5px;
  }

  .switch {
    display: flex;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    margin-top: 28px;
    line-height: 25px;

    .tab {
      color: #333333;
      font-weight: 500;
      font-size: 18px;
      height: 32px;
      position: relative;
      box-sizing: border-box;
      cursor: pointer;
    }

    .active {
      color: #266eff;
      font-weight: 600;
      font-size: 18px;
      //   width: 100%;
      height: 32px;
      position: relative;
      border-bottom: 2px solid #266eff;
      box-sizing: border-box;

      .line {
        position: absolute;
        width: 100%;
        height: 2px;
        background: #266eff;
        bottom: 0px;
      }
    }
  }
}
</style>
